import { videoFormat } from './videoFormat';

export default {
  computed: {
    selectedVideoFormat() { return videoFormat(this.vid) || videoFormat(this.options); },
  },
  watch: {
    player(player) {
      if (!player || !this.selectedVideoFormat) return;
      player.ready(() => {
        if (player.isDisposed()) return;
        this.applyVideoFormat();
        player.on(['loadedmetadata', 'fullscreenchange', 'techready'], this.applyVideoFormat);
      });
    },
    selectedVideoFormat() { this.$nextTick(this.applyVideoFormat); },
  },
  methods: {
    applyVideoFormat() {
      const player = this.player;
      const format = this.selectedVideoFormat;
      if (!format || !player || player.isDisposed()) return;
      const [width, height] = format.split(':').map(Number);
      player.aspectRatio(format);
      player.fluid(true);
      const el = player.el();
      el.classList.add('gv-selected-format');
      const fullscreen = player.isFullscreen();
      Object.entries({ width: '100%', height: fullscreen ? '100%' : '0px',
        'padding-top': fullscreen ? '0px' : `${height / width * 100}%`, 'max-height': 'none' })
        .forEach(([key, value]) => el.style.setProperty(key, value, 'important'));
      // The old landscape-only YouTube crop must never stretch a portrait source.
      const iframe = el.querySelector('iframe');
      if (iframe) Object.entries({ width: '100%', height: '100%', top: '0px', left: '0px', transform: 'none', 'max-width': 'none' })
        .forEach(([key, value]) => iframe.style.setProperty(key, value, 'important'));
    },
  },
};
